<template>
  <div>
    <FaqMenu v-if="!embed" />

    <div :class="embed ? '' : 'container'">

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          How do I find PFX property auctions?
        </h2>
        <div>
          PFX auctions can be accessed through the websites of participating brokers, online marketing channels or directly through PFX.com. <a href="/listings">Browse broker-powered auctions on PFX now</a>.
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          How do I sign-up to bid on an auction?
        </h2>
        <div>
          <p>In order to bid on a PFX property auction, you will first need to <a href="/sign-in-required">create a PFX account</a>. You can then register for an auction by completing the application form and submitting the required documents for review and approval. These documents are specified by the broker for each auction and can range from bank statements and lender letters to articles of incorporation/LLC, etc. </p>
          <p>Once you complete your application and submit the required documents via PFX, the broker will review your application and either accept or decline your application to bid. You will receive notification by email of your application status.</p>
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          I’m an agent representing a seller. Can I sign-up on his or her behalf?
        </h2>
        <div>
          Yes, buyer agents are welcome! Join PFX now to register for an auction!
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          Why do I have to apply to bid on an auction?
        </h2>
        <div>
          The PFX auction platform gives sellers certainty of close of escrow and qualified buyers equal opportunity to purchase real estate. With PFX, the highest bid wins every time so you never have to worry about multiple counter offers or blindly submitting "highest and best price." You can monitor bidding in real-time and have the opportunity to outbid competitors until such time as the auction closes. PFX auctions simplify the sales process while providing price transparency.
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          My application to bid on an auction was declined. Can I question the decision?
        </h2>
        <div>
          The broker’s decision on a buyer’s application is final. You can message the broker directly with any questions regarding your application.
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          How do I complete due diligence on a PFX property auction? How much time do I have?
        </h2>
        <div>
          <p>With PFX, all due diligence is completed before the auction period begins. The broker sets a registration period during which time you’ll have the opportunity to review broker-provided documents, arrange inspections and set up viewings with the broker. Due diligence documents can be accessed via a secure Document Vault. Once the registration period ends, the auction period begins.</p>

          <p>The registration period and auction period are set by the broker and vary depending on the seller’s needs.</p>
        </div>
      </div>


      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          What can I expect from the auction process?
        </h2>
        <div>
          <p>Once you have registered to participate in a PFX property auction, it will appear in your dashboard. From here, you can view/access property and auction details including your registration status, the auction & registration periods, due diligence documents for each auction, current bid, auction status and more.</p>

          <p>Once an auction starts, you can monitor bidding in real-time via your dashboard. Set up automatic bidding so you never miss an opportunity to outbid competitors. Specify bid increments and your maximum price for each auction.</p>

          <p>When the auction closes, the highest bidder that meets or exceeds the reserve prices, wins. You will be notified via email on the outcome of the auction. If you have won the auction, you sign the purchase agreement to open escrow.</p>
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          How do I bid on an auction?
        </h2>
        <div>
          <p>To bid on an auction, select the property auction from your dashboard and click on ‘Bid’. You can then select the bid amount or follow the instructions to set-up auto bidding.</p>
          <p>The auto bidding feature will automatically place a bid on your behalf in the increments you specify, to the maximum amount you specify. For example, if you set autobid to bid in $5,000 increments and a competing bidder places a bid for $500,000, PFX will automatically bid $505,000 on your behalf. If you set the maximum bid to $600,000 on a property and a competing bidder places a bid for $600,000, PFX will not place a bid on your behalf.</p>
          <p>The autobid feature saves you time so you don’t have to continuously monitor bidding activity. Autobid can be turned on or off at any time.</p>
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          Are there any fees to bid on a PFX property auction?
        </h2>
        <div>
          No, approved bidders can place as many bids as they wish at no cost.
        </div>
      </div>

      <div class="faq-question-container">
        <h2 @click="toggleSection($event.target)">
          I’m an agent and would like to sell my client’s properties on PFX. How do I sign-up?
        </h2>
        <div>
          In order to start auctioning listings, you will need to create a PFX brokerage account. Click ‘<a @click="$store.commit('openGetStartedDialog')">Get Started</a>’ to complete the application form. Once the PFX team approves your application (within 24 hours) and you have selected the PFX plan that meets your needs, you can begin auctioning your listings. For more information, visit the <a href="/faq/agents">Broker FAQs</a>.
        </div>
      </div>

    </div>

    <div class="videos clearfix" v-if="!embed && hideVideos">
      <div class="column video1">
        <h2>Watch PFX Videos to learn more</h2>
      </div>
      <div class="column video2 pointer" @click="$store.commit('openYouTubeDialog', 'E5yFcdPAGv0')"><!-- TODO change video -->
        <div class="title">Get Started <div class="length">5:40</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video3 pointer" @click="$store.commit('openYouTubeDialog', 'HyHNuVaZJ-k')"><!-- TODO change video -->
        <div class="title">Create Listing <div class="length">8:00</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video4 pointer" @click="$store.commit('openYouTubeDialog', 'GgwE94KZJ7E')"><!-- TODO change video -->
        <div class="title">Approve Bidding <div class="length">4:32</div></div>
        <div class="play"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import FaqMenu from './FaqMenu.vue'

  export default {
    name: 'FaqAgents',
    components: {
      FaqMenu
    },
    props: {
      embed: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        openSection: '',
        hideVideos: process.env.config.frontend.hideVideos
      }
    },
    methods: {
      toggleSection(e) {
        const current = e.nextElementSibling.style.display
        e.nextElementSibling.style.display = current === 'block' ? 'none' : 'block'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .faq-question-container {
    h2 {
      font-family: 'Encode Sans', sans-serif;
      font-size: 16px;
      font-weight: 600;
    }
    div {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FaqBuyers.vue